import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { apiClient } from '@/api/client'

export function useIsTeamAdmin(teamId?: string) {
  const { user, getAccessTokenSilently } = useAuth0()

  return useQuery({
    queryKey: ['is-team-admin', user?.sub, teamId],
    queryFn: async () => {
      if (!teamId) return false
      
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      
      try {
        const response = await apiClient.get(`/teams/${teamId}/members`)
        // If we can access the members endpoint, we're an admin
        return true
      } catch (error) {
        // If we get a 403, we're not an admin
        return false
      }
    },
    enabled: !!user && !!teamId,
  })
}
